
import React, { useState, useEffect } from 'react';
import rsilogo from '../Assets/logo.svg'
import seglogo from '../Assets/seg-logo.png'
import profile from '../Assets/profile.svg'
import config from '../../Context/Config'
import HelpForm from './help_form';

function Header({ pageTitle }) {
    const [logoSrc, setLogoSrc] = useState("");
    const [showHelpPopup, setShowHelpPopup] = useState(false);

    useEffect(() => {
        // Retrieve the item from localStorage
        const storedLogo = config.practice;

        // Check the value and set the logo accordingly
        if (storedLogo === "rsi") {
            setLogoSrc(rsilogo);
        } else {
            setLogoSrc(seglogo);
        }
    }, []);

    return (
        <header className="bg-white/40 shadow px-4 py-2 flex flex-wrap md:flex-nowrap items-center justify-between h-auto md:h-20 gap-4">
            {/* Logo */}
            <img
                src={logoSrc}
                alt="Logo"
                className="w-16 h-auto pointer-events-none"
            />

            {/* Page Title */}
            <h1 className="text-xl font-semibold text-blue-600 text-center flex-grow font-['Roboto']" id="header">
                {pageTitle}
            </h1>

            <button
                onClick={() => setShowHelpPopup(true)}
                type="button"
                className="bg-blue-600 text-white py-1 px-3 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm flex items-center"
                aria-label="Open Help Form"
            >
                <i className="fas fa-circle-question mr-1" aria-hidden="true" />
                Help
            </button>

            {showHelpPopup && <HelpForm onClose={() => setShowHelpPopup(false)} />}
        </header>


    );
}

export default Header;
